module.exports = __webpack_public_path__ + "img/UserIconGrey.e94f7fcc.svg";